import type { SessionBlockEntityType } from "@/modules/sessions/entities/sessionBlockEntity"
import { UserEntity } from "@modules/profile/userProfile/userEntity"

export type CalendarEventStyle = {
  top: number
  left: number | string
  height: number
  width: number | string
}

export enum CalendarEventTypes {
  CALENDAR_EVENT = "CALENDAR_EVENT",
  UNDATED_EVENT = "UNDATED_EVENT",
  CALENDAR_EVENT_WITH_HOUR = "CALENDAR_EVENT_WITH_HOUR",
  SLOT_TEMPLATE_EVENT = "SLOT_TEMPLATE_EVENT",
}

type CalendarEventType = {
  id: string
  virtualProgramByDateIndex?: number
  title: string
  content?: string
  date: string
  color?: string
  textColor?: string
  editable: boolean
  _type: CalendarEventTypes.CALENDAR_EVENT
}

type UndatedEventType = {
  id: string
  title?: string
  content?: string
  dayIndex: number
  restDay: boolean
  color?: string
  textColor?: string
  editable: boolean
  _type: CalendarEventTypes.UNDATED_EVENT
}

export type CalendarEventTypeWithHour = {
  id: string
  programmationId: string
  title: string
  content?: string
  date: string
  startDate: string
  endDate: string
  color?: string
  borderColor?: string
  borderStyle?: string
  leftBorderColor?: string
  textColor?: string
  editable: boolean
  participantLimit?: number
  style?: CalendarEventStyle
  _type: CalendarEventTypes.CALENDAR_EVENT_WITH_HOUR
  assignedStaffMembers?: UserEntity[]
}

export type SlotTemplateEventType = {
  id: string
  title?: string
  programId: string
  content?: string
  dayIndex: number
  startDate: string
  endDate: string
  color?: string
  textColor?: string
  borderColor?: string
  borderStyle?: string
  leftBorderColor?: string
  editable: boolean
  style?: CalendarEventStyle
  _type: CalendarEventTypes.SLOT_TEMPLATE_EVENT
  assignedStaffMembers?: UserEntity[]
  participantLimit?: number
}

export type EventType = CalendarEventType | UndatedEventType | CalendarEventTypeWithHour | SlotTemplateEventType

export type ProgramCalendarEventType = EventType & {
  blocks: SessionBlockEntityType[]
  cardioTag?: boolean
  gymnasticTag?: boolean
  weightliftingTag?: boolean
  hideSessionContent: boolean
}
